function parentalSkillsAtWork() {
  return [
    {
      title: "Lo stress nella genitorialità",
      description:
        "Scopriamo come lo stress possa essere un fenomeno positivo di superamento dei propri limiti se gestito in maniera adeguata",
      imageSrc: "images/parental-skills/thumbnail-1.webp",
    },
    {
      title: "Come gestire le differenti opinioni",
      description: "Imparare a trarre da conflitto benefici di cambiamento",
      imageSrc: "images/parental-skills/thumbnail-2.webp",
    },
    {
      title: "Genitorialità e cambiamento",
      description:
        "Responsabilità, accettazione e nuova percezione dell’altro: come cambia la consapevolezza dopo la nascita del proprio bambino",
      imageSrc: "images/parental-skills/thumbnail-3.webp",
    },
  ];
}

export { parentalSkillsAtWork };
